import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConsultaManutencaoVestaSugestoes } from 'src/app/@feature/cadastro/cadastros/cadastro-home-vesta/manutencao-sugestoes/manutencao-vesta-sugestoes.model';
import { BaseCrudService, montarQueryString } from '../base-crud/base-crud.service';

@Injectable({
  providedIn: 'root'
})

export class ManutencaoVestaSugestoesService extends BaseCrudService {

  /*
    Informar a rota do Controller correspondente na API
    */
  apiController = "HomeVesta";

  /*
  URLS principais
  */
  consultarUrl = (input: ConsultaManutencaoVestaSugestoes) => `FiltrarSugestoes?${montarQueryString(input)}`;
  excelUrl = (input: ConsultaManutencaoVestaSugestoes) => `ExportarGridSugestoes?${montarQueryString(input)}`;
  atualizarUrl = (input: any) => `AlterarSugestoes`;
  cadastrarUrl = (input: any) => `InserirSugestoes`;

  constructor(public override http: HttpClient) {
    super(http);
  }

  public responderSugestao(obj): Observable<any> {
    return this.post(`ResponderSugestoes`, obj);
  }
 
}
